import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Login from '../views/Login.vue'
import FileManager from '../views/FileManager.vue';
import Test from '../views/Test.vue';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: Index,
    meta: {
      auth: true
    },
    children: [{
        path: '',
        name: 'index',
        component: () => import('@/views/recommend/Index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'material-library',
        name: 'material-library',
        component: () => import('@/views/materialLibrary/index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'third-party-material',
        name: 'third-party-material',
        component: () => import('@/views/thirdPartyDatabase/Index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/recommend/Index.vue'),
        meta: {
          auth: true
        },
      }
    ]
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
    meta: {
      auth: true
    },
    children: [{
        path: '',
        name: 'index',
        component: () => import('@/views/recommend/Index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'material-library',
        name: 'material-library',
        component: () => import('@/views/materialLibrary/index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'third-party-material',
        name: 'third-party-material',
        component: () => import('@/views/thirdPartyDatabase/Index.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/recommend/Index.vue'),
        meta: {
          auth: true
        },
      }
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/index.vue')
  },
  {
    path: '/file-manager',
    name: 'file-manager',
    component: FileManager,
    meta: {
      auth: true
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
